@if (shouldShowControl()) {
  <div>
    @for (config of controlConfig.toRenderControlConfigs; track config) {
      <gk-control-renderer [data]="getDataWithFilteredData()" [controlConfig]="config"></gk-control-renderer>
    }
  </div>
}
